const t = {
  name: "ArrowLeft",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.4139 11.0001L11.4139 5.00015L9.99966 3.58594L1.58545 12.0002L9.99966 20.4144L11.4139 19.0002L5.41385 13.0001L21.9998 13.0001V11.0001L5.4139 11.0001Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as ArrowLeft
};
